function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import PlatformUsers from "./PlatformUsers";
import Permissions from "../permissions/Permissions";

var AdministratorsTabs = function AdministratorsTabs(props) {
  var admins = props.admins,
      permissionsAdmins = props.permissionsAdmins,
      token = props.token;

  var _React$useState = React.useState("administrators"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "administrators-tabs-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs",
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("li", {
    className: activeTab === "administrators" ? "active" : ""
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setActiveTab("administrators");
    }
  }, "Ejecutivos")), /*#__PURE__*/React.createElement("li", {
    className: activeTab === "permissions" ? "active" : ""
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setActiveTab("permissions");
    }
  }, "Permisos"))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, activeTab === "administrators" && /*#__PURE__*/React.createElement(PlatformUsers, {
    admins: admins,
    token: token
  }), activeTab === "permissions" && /*#__PURE__*/React.createElement(Permissions, {
    admins: permissionsAdmins,
    token: token
  }))));
};

export default AdministratorsTabs;